import cloneDeep from "lodash-es/cloneDeep";
import { PER_PAGE_OPTIONS } from "~/modules/settings/variables/PerPageOptions";
import { SEARCH_SORT_OPTIONS } from "~/modules/settings/variables/SearchSortOptions";

export function useSettings() {
  const { t } = useI18n();

  return {
    perPageOptions: cloneDeep(PER_PAGE_OPTIONS),
    searchSortOptions: cloneDeep(SEARCH_SORT_OPTIONS).map((op) => {
      op.label = t(op.label) as string;
      return op;
    }),
  };
}
